import React from 'react';
import * as R from 'ramda';
import { pure, compose, withHandlers } from 'react-recompose';
// features
import BranchTree from '../../../../branch/components/branch-tree';
// helpers/constants
import * as G from '../../../../../helpers';
import * as GC from '../../../../../constants';
// icons
import * as I from '../../../../../svgs';
// ui
import { Box, Flex } from '../../../../../ui';
//////////////////////////////////////////////////

const enhance = compose(
  withHandlers({
    handleEdit: (props) => () => {
      const { openModal, closeModal, handleFormSubmit } = props;

      const component = (
        <BranchTree
          width={600}
          allowSelect={true}
          rootDisabled={true}
          initiallyExpanded={true}
          closeAction={closeModal}
          useFromCurrentAndDown={true}
          branchTypeFilter={GC.BRANCH_TYPE_ENUM_DIVISION}
          initialSelectedList={R.pathOr([], ['initialValues', GC.CARRIER_ALLOW_EDITING_FOR_DIVISIONS], props)}
          handleMultipleSelect={(value) => {
            handleFormSubmit({ [GC.CARRIER_ALLOW_EDITING_FOR_DIVISIONS]: value });
            closeModal();
          }}
        />
      );

      const modal = {
        p: '0px',
        component,
        options: {
          width: 500,
          height: 'auto',
          minWidth: 'fit-content',
          title: G.getWindowLocale('titles:select-divisions', 'Select Divisions'),
        },
      };

      openModal(modal);
    },
  }),
  pure,
);

const AllowedDivisions = (props) => {
  const configList = R.pathOr([], ['initialValues', GC.CARRIER_ALLOW_EDITING_FOR_DIVISIONS], props);

  return (
    <Flex mr={15} height={55}>
      <Flex>
        {
          R.isEmpty(configList) &&
          <Box>{G.getWindowLocale('titles:no-divisions', 'No Divisions')}</Box>
        }
        {
          configList.map((guid, i) => (
            <Box mr='6px' key={i}>
              {`${R.path(['branchList', guid, GC.BRANCH_NAME], props)}${
                G.ifElse(R.lt(i, R.dec(R.length(configList))), ',', '')
              }`}
            </Box>
          ))
        }
      </Flex>
      <Box ml={16} cursor='pointer' onClick={props.handleEdit}>
        {I.renderEditIcon(G.getTheme('icons.iconColor'))}
      </Box>
    </Flex>
  );
};

export default enhance(AllowedDivisions);
